import React from "react";

const NewsDetail = ({
  news,
  expanded,
  showReadMore = false,
}: {
  news: any;
  expanded: boolean;
  showReadMore?: boolean;
}) => {
  let readMoreText: any = null;
  if (showReadMore) {
    if (expanded) {
      readMoreText = "Show Less";
    } else {
      readMoreText = "Show More";
    }
  }

  return (
    <div>
      {showReadMore ? <div>{readMoreText}</div> : null}
      {expanded ? <div>{news.analysis}</div> : null}
    </div>
  );
};

export default NewsDetail;
